import { render } from "./fourteen-service.vue?vue&type=template&id=2636892f"
import script from "./fourteen-service.vue?vue&type=script&lang=js"
export * from "./fourteen-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__